import styled from "styled-components";

import { colors } from "../../../constants/colors";

export type StyledSelectProps = {
  height?: string;
  width?: string;
  fontSize?: string;
};

export const StyledSelect = styled.select`
  background: ${colors.form.background};
  font-size: ${({ fontSize }: StyledSelectProps) => fontSize || "16px"};
  height: ${({ height }: StyledSelectProps) => height || "2rem"};
  width: ${({ width }: StyledSelectProps) => width || "10rem"};
  border-radius: 1px;
  border: 0px;

  &:disabled {
    background: ${colors.disable};
  }

  &:focus {
    background: ${colors.form.focused};
  }
`;
